import { Action } from '../../common/actions/core/action';

export class OpenPacketImmediateDeleteSuccessAction implements Action {
    constructor(
    ){}
}



// WEBPACK FOOTER //
// src/app/packet/packet-delete-immediate-success-dialog/packet-delete-immediate-success-dialog.action.ts